// extracted by mini-css-extract-plugin
var _1 = "constants_disabled__627e7";
var _2 = "constants_italic__cfbaf";
export { _1 as "disabled", _2 as "italic" }
